var PathUtil = /** @class */ (function () {
    function PathUtil() {
    }
    PathUtil.currentPath = function () {
        return window.location ? window.location.pathname : '';
    };
    PathUtil.prefixRegExp = function (langCode) {
        if (langCode === void 0) { langCode = 'ja'; }
        var prefix = '^/[A-Za-z]{2}/';
        if (langCode) {
            prefix = "^/".concat(langCode, "/");
        }
        return prefix;
    };
    PathUtil.regtest = function (pattern, value) {
        var regExp = new RegExp(pattern);
        return regExp.test(value);
    };
    PathUtil.isCatalogPage = function (path, langCode) {
        if (path === void 0) { path = this.currentPath(); }
        if (langCode === void 0) { langCode = 'ja'; }
        var pattern = "".concat(PathUtil.prefixRegExp(langCode), "co/([0-9]*)/catalog/.*");
        return this.regtest(pattern, path);
    };
    PathUtil.isSearchCatalogPage = function (path, langCode) {
        if (path === void 0) { path = this.currentPath(); }
        if (langCode === void 0) { langCode = 'ja'; }
        var pattern = "".concat(PathUtil.prefixRegExp(langCode), "s\\/catalog.*");
        return this.regtest(pattern, path);
    };
    return PathUtil;
}());
export { PathUtil };
